import { Colors } from '../Colors';
export var helperViewHintList = {
  success: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.success
  },
  'success-dim': {
    color: Colors.text.success,
    backgroundColor: Colors.ut.successDim
  },
  warning: {
    color: Colors.text.buttonInverse,
    backgroundColor: Colors.ut.warning
  },
  error: {
    color: Colors.text.buttonDefault,
    backgroundColor: Colors.ut.error
  },
  'error-dim': {
    color: Colors.text.error,
    backgroundColor: Colors.ut.errorDim
  },
  danger: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.alert
  },
  info: {
    color: Colors.text["default"],
    backgroundColor: Colors.ut.help
  },
  alert: {
    color: Colors.text.alert,
    backgroundColor: Colors.ut.alertDim
  },
  buy: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.primary
  },
  sell: {
    color: Colors.text.inverse,
    backgroundColor: Colors.ut.alert
  }
};
//# sourceMappingURL=utils.js.map